module.exports = __webpack_public_path__ + "img/wts.252d1a85.png";